export interface ValidationResult {
  isValid: boolean;
  message: string;
}

export const phoneRegex = /^(?:\+?\d{1,3}[\s.\-]?(?:\(?\d{1,4}\)?[\s.\-]?)?\d{3,4}[\s.\-]?\d{4,9}|\(?0[2378]\)?[\s.\-]?\d{8}|04\d{2}[\s.\-]?\d{3}[\s.\-]?\d{3}|\d{8})$/;

export const validatePhoneNumber = (number: string): ValidationResult => {
  const trimmedNumber = number.trim();
  
  if (!trimmedNumber) {
    return { isValid: false, message: 'Phone number is required' };
  }
  
  // Remove all non-digit characters for length validation
  const digitsOnly = trimmedNumber.replace(/\D/g, '');
  
  // Validate length
  if (digitsOnly.length < 10) {
    return { isValid: false, message: 'Phone number is too short' };
  }
  
  if (digitsOnly.length > 15) {
    return { isValid: false, message: 'Phone number is too long' };
  }
  
  // Validate phone number pattern (allows for international numbers)
  if (!phoneRegex.test(trimmedNumber)) {
    return { isValid: false, message: 'Please enter a valid phone number' };
  }
  
  return { isValid: true, message: '' };
};

export const cleanPhoneNumberInput = (input: string): string => {
  // Remove all characters except numbers, +, -, (, ), and spaces
  return input.replace(/[^0-9+\-()\s]/g, '');
};
